import { DataLayerEvent } from "../events/DataLayerEvent";
import { EventActionValue, EventCategory } from "../BNGoogleTagManager";

export class AdjustableDataLayerEvent extends DataLayerEvent {
  constructor(eventName: string, fields: Record<string, unknown>, isOneFlow?: boolean) {
    const mappedEventName = mapEventName(eventName, isOneFlow);
    super({
      eventName: mappedEventName !== "unknown" ? mappedEventName : eventName,
      data: setupData(fields) as any,
    });
  }
  override toGaObject(): object {
    return super.toGaObject();
  }
}

const setupData = (fields: Record<string, unknown>): Record<string, unknown> => {
  const data: Record<string, unknown> = {};
  Object.entries(fields).forEach(([key, value]) => {
    const mapped = mapEventActionValue(value as EventActionValue);
    data[key] = mapped !== "unknown" ? mapped : typeof value === "object" && value !== null ? value : value?.toString();
  });
  return data;
};

const mapEventActionValue = (action: EventActionValue): string | unknown => {
  switch (action) {
    case EventActionValue.CrossSellID1:
      return "cs_1";
    case EventActionValue.CrossSellID2:
      return "cs_2";
    case EventActionValue.CrossSellAddOn:
      return "CC Cross sell add-on checktype item";
    case EventActionValue.CrossSellBanner:
      return "CC Cross sell banner";
    case EventActionValue.CreditCardCrossSellItem:
      return [
        {
          item_id: "5",
          item_name: "Credit card",
          item_variant: "Cross sell",
        },
      ];
    case EventActionValue.Ppi:
      return "PPI";
    default:
      return "unknown";
  }
};

const mapEventName = (action: string, isOneFlow?: boolean): string => {
  switch (action) {
    case EventCategory.ViewPromotion:
      return "view_promotion";
    case EventCategory.SelectPromotion:
      return "select_promotion";
    case EventCategory.LoanApplication:
      return isOneFlow ? "my_ul_application_oneflow" : "my_ul_application";
    case EventCategory.ViewItem:
      return "view_item";
    case EventCategory.Purchase:
      return "purchase";
    case EventCategory.AddToCart:
      return "add_to_cart";
    case EventCategory.RemoveFromCart:
      return "remove_from_cart";
    default:
      return "unknown";
  }
};
